import { filterOptions } from '@/utils/query-base'

const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
export const pageSearch = {
  'ctrlType': {
    title: '发货控制',
    type: 'select',
    equation: all,
    dictionary: 'DeliveryRange'
  },
  'saleCenter': {
    title: '营销中心',
    type: 'select',
    equation: all,
    dictionary: 'sale'
  },
  'base': {
    title: '基地',
    type: 'select',
    equation: all,
    dictionary: 'base'
  },
  'customerCode': {
    title: '客户',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect'
    }
  },
  'productType': {
    title: '存货分类',
    type: 'select',
    equation: all,
    dictionary: 'A0019'
  }
}

export default {
  'ctrlTypeTextView': {
    title: '发货控制'
  },
  'saleCenterName': {
    title: '营销中心'
  },
  'baseName': {
    title: '基地'
  },
  'customerCode': {
    title: '客户编码',
    width: 180
  },
  'customerName': {
    title: '客户名称',
    width: 200
  },
  'stockTypeTextView': {
    title: '存货分类',
    width: 180
  },
  'planYieldGreater': {
    title: '计划量>='
  },
  'planYieldLess': {
    title: '计划量<='
  },
  'interval': {
    title: '间隔天数'
  },
  'frequency': {
    title: '次/月'
  },
  'createdDate': {
    title: '创建日期',
    width: 180
  }
}



// WEBPACK FOOTER //
// ./src/views/apply-for-manage/data-searching/config/deliveryContralSearch.js